import { Filter } from 'lucide-react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { ModerationFilters as ModerationFiltersType } from '@/lib/api/modules/social-listening'

type Props = {
  filters: ModerationFiltersType
  onChange: (filters: ModerationFiltersType) => void
}

export function ModerationFilters({ filters, onChange }: Props) {
  return (
    <div className="flex items-center gap-3 flex-wrap">
      <Filter className="h-4 w-4 text-muted-foreground" />

      <Select
        value={filters.intent || 'all'}
        onValueChange={(v) =>
          onChange({ ...filters, intent: v === 'all' ? undefined : v, page: 1 })
        }
      >
        <SelectTrigger className="w-40">
          <SelectValue placeholder="Tipo" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos</SelectItem>
          <SelectItem value="complaint">Reclamação</SelectItem>
          <SelectItem value="spam">Spam</SelectItem>
          <SelectItem value="question">Pergunta</SelectItem>
          <SelectItem value="positive">Elogio</SelectItem>
          <SelectItem value="neutral">Neutro</SelectItem>
        </SelectContent>
      </Select>

      <Select
        value={filters.action || 'all'}
        onValueChange={(v) =>
          onChange({ ...filters, action: v === 'all' ? undefined : v, page: 1 })
        }
      >
        <SelectTrigger className="w-40">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos</SelectItem>
          <SelectItem value="hidden">Ocultado</SelectItem>
          <SelectItem value="failed_to_hide">Falhou</SelectItem>
          <SelectItem value="unhidden">Desocultado</SelectItem>
          <SelectItem value="none">Sem ação</SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}
